// extracted by mini-css-extract-plugin
export default {"wrapperDetails":"LectureDetails_wrapperDetails__y7Z-y"};